<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :totalData="totalData"
      @reload="reload"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <template>
          <el-badge
            v-if="allow('E')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="exportFile()"
            >
              {{ $l('INDEX.btn_export') || '导出' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>

          <el-badge
            v-if="allow('U')"
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            :disabled="checkedRowCount < 1"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-primary"
              :disabled="checkedRowCount < 1"
              @click="batchUpdateInv()"
            >
              {{ $l('btn_batch_update_inv') || '批量更新库位' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
        </template>
      </page-header>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <BatchUpdate
      v-if="batchUpdateDialogOptions.visible"
      :visible.sync="batchUpdateDialogOptions.visible"
      @confirm="onConfirmUpdate"
    ></BatchUpdate>
    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-skuinvftylocationdetails' }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
      @export-success="clearCheckboxRow"
    />
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageHeader from './header'
import PageMain from './main.vue'
import chooseTemplate from '@/views/ecom/components/choose-template'
import BatchUpdate from '../batch-update'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, chooseTemplate, BatchUpdate },
  data() {
    return {
      usePage: true,
      checkedRows: [],
      currSearchForm: {},
      totalData: {},
      chooseTemplateOptions: { visible: false },
      batchUpdateDialogOptions: { visible: false },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    async getData(form) {
      const params = {
        ...form,
        ...this.page,
      }
      this.getTotalData(params)
      this.loading = true
      this.currSearchForm = form
      await this.getTableData(params)
      this.loading = false
    },
    async getTableData(params) {
      const res = await this.$api
        .ecomAmzSkuInvFtyLocationListApi(params)
        .catch(() => null)
      if (res) this.setData(res)
    },
    async getTotalData(params) {
      this.totalData = {}
      const res = await this.$api
        .ecomAmzSkuInvFtyLocationListTotalApi(params)
        .catch(() => null)
      this.totalData = res?.body || {}
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    exportFile() {
      if (!this.tableData || !this.tableData.length) {
        this.$message({
          message:
            this.$l('tips_exportEmptyData') ||
            '当前条件无匹配库存数据，请修改查询后重试！',
          type: 'warning',
        })
        return
      }

      const listInvFtyLocationCode =
        this.checkedRows?.map((item) => item.invFtyLocationCode) || []
      const searchForm = {
        ...this.currSearchForm,
        sortFields: this.sortFields,
        listInvFtyLocationCode,
      }

      this.chooseTemplateOptions = { visible: true, searchForm }
    },
    batchUpdateInv() {
      this.batchUpdateDialogOptions.visible = true
    },
    async onConfirmUpdate({ inLocationNo }) {
      if (this.loadingOpen()) return
      const invFtyLocationCodes =
        this.checkedRows?.map((item) => item.invFtyLocationCode) || []
      const res = await this.$api
        .ecomAmzStorageLocationsUpdateApi({
          inLocationNo,
          invFtyLocationCodes,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      if (200 !== res.status) {
        this.$message.error(this.$l('message_update_error') || '更新失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('message_update_success') || '更新成功',
        type: 'success',
      })
      this.clearCheckboxRow()
      this.reload()
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
